<template>
  <form
    id="product_condition_switcher"
    class="bg-static-default-mid border-static-default-low rounded-sm mx-auto flex w-fit flex-wrap border-1 p-4"
    @submit.prevent
  >
    <fieldset class="flex flex-row">
      <label
        class="rounded-sm body-1-bold relative flex w-fit cursor-pointer flex-row items-center px-12 py-8"
        :class="getLabelClasses(selectedValue === 'body')"
      >
        <IconSmartphone class="mr-8" size="24" />
        <span>{{ i18n(translations.body) }}</span>
        <input
          id="switcher"
          v-model="selectedValue"
          :aria-checked="selectedValue === 'body'"
          class="invisible absolute inset-0"
          name="switcher"
          type="radio"
          value="body"
        />
      </label>
      <label
        class="rounded-sm body-1-bold relative flex w-fit cursor-pointer flex-row items-center px-12 py-8"
        :class="getLabelClasses(selectedValue === 'screen')"
      >
        <IconScratches class="mr-8 flex" size="24" />
        <span>{{ i18n(translations.screen) }}</span>
        <input
          id="switcher"
          v-model="selectedValue"
          :aria-checked="selectedValue === 'screen'"
          class="invisible absolute inset-0"
          name="switcher"
          type="radio"
          value="screen"
        />
      </label>
    </fieldset>
  </form>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconScratches } from '@ds/icons/IconScratches'
import { IconSmartphone } from '@ds/icons/IconSmartphone'

import translations from './ProductConditionSwitcher.translations'
import type { SwitcherValue } from './ProductConditionSwitcher.types'

const i18n = useI18n()

const selectedValue = defineModel<SwitcherValue>({ default: 'body' })

function getLabelClasses(selected: boolean) {
  return selected
    ? 'bg-action-default-mid-pressed text-onaction-default-mid-pressed'
    : 'bg-action-default-min text-action-default-low-pressed'
}
</script>
